import React from "react";
import { Link } from "react-router-dom";
import "./styles.scss";
import Logo from "components/atoms/logo/index.jsx";
import CompanyInfo from "components/atoms/companyInfo/index.jsx";
import ArrowLink from "components/atoms/arrowLink/index.jsx";

export default class Modal extends React.Component {
  render() {
    return (
      <>
        {this.props.open && (
          <div className="modal">
            <div className="image">
              <img src={this.props.image} alt="" />
            </div>
            <div className="overlay"></div>
            <div className="close">
              <div className="close-button ">
                <ArrowLink>Cerrar</ArrowLink>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
